import { LogoSelectionDropdown } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/components/broadcastComponents/LogoSelectionDropdown';
import {
  FrameActionType,
  PostLogoFor,
  PostPresenceFor,
  TBroadcastScheduleOnUpdateInline,
} from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/types';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { TClipLogo } from '@/features/clips/types';
import { TLogo } from '@/features/logos/types';
import { TSegmentLogo } from '@/features/segments/types';

import { PresenceInlineDropdown } from './PresenceInlineDropdown';

type LogoPresenceDropdownProps<T extends TSegmentLogo | TClipLogo> = {
  item: T;
  /** The logos the table has resolved for its rows; a row never asks for its own. */
  logosById: ReadonlyMap<string, TLogo>;
  onUpdateInline?: TBroadcastScheduleOnUpdateInline<PostLogoFor<T>>;
  onPreview?: (item: T, frame?: FrameActionType) => void;
  hasParent?: boolean;
  parentCallback?: () => void;
  buildDataToSave?: (item: T) => PostPresenceFor<T>;
};

export function LogoPresenceDropdown<T extends TSegmentLogo | TClipLogo>({
  item,
  logosById,
  ...rest
}: LogoPresenceDropdownProps<T>) {
  const { logoData } = useBroadcastScheduleProgram();

  const logoId = 'logo_id' in item ? item.logo_id : (item as { id: string }).id;
  const logo = logoId ? logosById.get(logoId) : undefined;

  const imageConfig = {
    url: logo?.parameters?.main_logo_presigned_url || '/default-logo.svg',
    alt: logo?.name || item.entity_label || '',
    contentClassName: 'justify-start w-[80px]',
  };

  return (
    <PresenceInlineDropdown
      item={item}
      imageConfig={imageConfig}
      renderDropdown={onChange => <LogoSelectionDropdown onChange={onChange} />}
      presenceData={logoData ?? undefined}
      {...rest}
    />
  );
}
